export const Paths = {
  searchByCpf: `/customer-portal/v1/person/patient`,
  searchByRne: `/customer-portal/v1/person/foreigner`,
};
